

import { useMsal } from "@azure/msal-react";

import { InteractionRequiredAuthError, AuthenticationResult } from "@azure/msal-browser";
import { useDispatch } from "react-redux";
import { loginRequest } from "../config/msal-config";
import { setAccessToken, showError } from "../store/slices/formconfig";
import '../styles/unauthorized.css'
import { Cover, LoginBack, Logo, PCLOGO } from "../constants";
import { useNavigate } from "react-router-dom";

const request = {
  scopes: ["User.Read"],
};


export const Login = () => {
  const { instance } = useMsal();
  const dispatch = useDispatch();
   const navigate = useNavigate();

  const handleTokenResponse = (response: AuthenticationResult) => {
    dispatch(setAccessToken(response.accessToken));
    return;
  }

  const handleLogin = async () => {
    try {
      // Use login popup and get the auth response
      const loginResponse: AuthenticationResult = await instance.loginPopup(loginRequest);

      // set active account so acquireTokenSilent knows which account to use
      if (loginResponse?.account) {
        instance.setActiveAccount(loginResponse.account);
      }

      // Try to acquire token silently
      try {
        const tokenResponse = await instance.acquireTokenSilent({ ...request, account: loginResponse.account });
        handleTokenResponse(tokenResponse as AuthenticationResult);
        navigate('/');
      } catch (silentErr) {
        if (silentErr instanceof InteractionRequiredAuthError) {
          const tokenResponse = await instance.acquireTokenPopup(request);
          handleTokenResponse(tokenResponse as AuthenticationResult);
          navigate('/');
        } else {
          dispatch(showError({ message: `Token acquisition failed: ${silentErr}`, visible: true }));
        }
      }
    } catch (error: any) {
      dispatch(showError({ message: `Login Failed, ${error}`, visible: true }));
      console.error(error);
    }
  };
  return (
    <div style={{ display: 'flex' }}>

      <div className="left-panel" style={{ backgroundImage: `url(${LoginBack})`, backgroundSize: 'cover' }}>
        <div className="left-panel-content">
          <h1>Empower Partners with Transparency</h1>
          <p>Digitize Certificates, ensure compliance.</p>
        </div>

        <div className="illustration-container">
          <img src={Cover} height={300} />
        </div>

        <div className="left-panel-content">
          <p className="tagline">One platform for all Certificates.</p>
        </div>
      </div>

      <div className="right-panel">
        <div>
          <div className="logo-section">
            <img src={PCLOGO} className="bayer-logo" />

          </div>

          <h2>Welcome to the <br /> Principal Certificate<br />  Management System..</h2>
          <p>Log in to review, approve, and track certificate requests.</p>
          <button className="sso-button" onClick={handleLogin}>Sign in with Bayer SSO</button>
        </div>
      </div>
    </div>
  )
}